import { Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { ServiceOrder } from 'src/app/data/model/service-order';
import { Waypoint } from 'src/app/data/model/waypoints';
import { OdsWaypointsApiService } from 'src/app/shared/api/services/ods-waypoints-api.service';
import { ServiceOrderApiService } from 'src/app/shared/api/services/service-order-api.service';
import { BaseEntityService } from 'src/app/shared/base/base-entity.service';

@Injectable({
  providedIn: 'root'
})
export class OdsWaypointsService extends BaseEntityService<
  Waypoint,
  OdsWaypointsApiService
> {
  constructor(
    apiService: OdsWaypointsApiService,
    private odsService: ServiceOrderApiService
  ) {
    super(apiService);
  }

  private odsSubject = new BehaviorSubject<ServiceOrder[] | null>(null);


  get ods$() {
    return this.odsSubject.asObservable();
  }

  loadODS() {
    this.odsService
      .getAll()
      .pipe(tap((res:any) => this.odsSubject.next(res.results)))
      .subscribe();
  }
}
